import { PublicClientApplication, InteractionRequiredAuthError, } from '@azure/msal-browser';
const config = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
        authority: import.meta.env.VITE_MSAL_AUTHORITY,
        knownAuthorities: ['hoawatchdev.ciamlogin.com', 'hoawatchprod.ciamlogin.com'],
        redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI ?? `${window.location.origin}/auth/callback`,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,
    },
    cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false },
    system: {},
};
export const msalInstance = new PublicClientApplication(config);
const API_SCOPE = import.meta.env.VITE_API_SCOPE;
export async function initializeMsal() {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
}
export function getActiveAccount() {
    return msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0] ?? null;
}
export async function loginRedirect() {
    await msalInstance.loginRedirect({ scopes: [API_SCOPE] });
}
export async function logoutRedirect() {
    await msalInstance.logoutRedirect();
}
export async function acquireApiToken(account) {
    const acc = account ?? getActiveAccount();
    if (!acc)
        return null;
    try {
        const r = await msalInstance.acquireTokenSilent({ scopes: [API_SCOPE], account: acc });
        return r.accessToken;
    }
    catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect({ scopes: [API_SCOPE], account: acc });
            return null; // browser will navigate away
        }
        throw e;
    }
}
